import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@fontsource/inter/latin.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@fontsource/inter/latin-italic.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/datadog-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/lib/registry.tsx");
